import {
  checkAlertPrice,
  createAlert,
  deleteAlert as deleteAlertGenerated,
  listAlerts,
  listAlertsBySymbol,
  resetAlert,
  setAlertEnabled,
  testNotification as testNotificationGenerated,
} from '../../generated/api/sdk.gen.js';
import type { AlertCheckResult, AlertStats, PriceAlert, PriceAlertCreate } from '../../generated/api/types.gen.js';
import { unwrapGenerated } from './generated.js';

// ==========================================
// Price Alert API
// ==========================================

export const alertApi = {
  async list(): Promise<{ data: PriceAlert[]; stats: AlertStats }> {
    const response = await unwrapGenerated(listAlerts());
    return { data: response.data, stats: response.stats };
  },

  async listBySymbol(symbol: string): Promise<PriceAlert[]> {
    const response = await unwrapGenerated(listAlertsBySymbol({ path: { symbol } }));
    return response.data;
  },

  async create(config: PriceAlertCreate): Promise<PriceAlert> {
    const response = await unwrapGenerated(createAlert({ body: config }));
    return response.alert;
  },

  async deleteAlert(id: string): Promise<void> {
    await unwrapGenerated(deleteAlertGenerated({ path: { id } }));
  },

  async setEnabled(id: string, enabled: boolean): Promise<boolean> {
    const response = await unwrapGenerated(setAlertEnabled({ path: { id }, body: { enabled } }));
    return response.enabled;
  },

  async reset(id: string): Promise<void> {
    await unwrapGenerated(resetAlert({ path: { id } }));
  },

  async checkPrice(symbol: string, price: number): Promise<AlertCheckResult> {
    return unwrapGenerated(checkAlertPrice({ body: { symbol, price } }));
  },
};

// ==========================================
// Webhook API
// ==========================================

export const webhookApi = {
  async getAlerts(): Promise<PriceAlert[]> {
    return (await alertApi.list()).data;
  },

  async createPriceAlert(config: PriceAlertCreate): Promise<PriceAlert> {
    return alertApi.create(config);
  },

  deleteAlert: alertApi.deleteAlert,

  async testNotification(channel?: string): Promise<void> {
    await unwrapGenerated(testNotificationGenerated({ body: { channel: channel as never } }));
  },
};
